import browser from 'browser-detect';

import { makeStyles } from '@material-ui/core/styles';

const currentBrowser = browser();

export const fullScreenDialogStyles = makeStyles(() => ({
  dialogPaper: {
    // This height: 100% is important to Chrome - without it, this wrapping-dialog scrolls
    // instead of the two columns when we're showing the note view
    height: '100%',

    // I'm not sure if this is strictly necessary anymore, but leaving it just in case
    position:
      currentBrowser.name === 'ie' && currentBrowser.versionNumber === 11 ? 'relative' : 'absolute',
  },
}));
